/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import {
  Button,
  Checkbox,
  Form,
  Grid,
  type CheckboxProps,
} from '@mairistem/composants';

import ModalGestionTrimestreRow from './ModalGestionTrimestreRow';

// @ts-expect-error
import iconEdition from '../../../../assets/images/edition.png';

interface ModalGestionTrimestreRowEditionProps {
  generation: Date;
  edition: Date;
  loading: boolean;
  onEdition: ({
    recenses,
    nonRecenses,
  }: {
    recenses: boolean;
    nonRecenses: boolean;
  }) => void;
  isClotured?: boolean;
}

const ModalGestionTrimestreRowEdition = (
  props: ModalGestionTrimestreRowEditionProps,
) => {
  const { generation, edition, loading, onEdition, isClotured = false } = props;

  const [visualisationLoading, setVisualisationLoading] =
    React.useState<boolean>(false);
  const [recenses, setRecenses] = React.useState<boolean>(false);
  const [nonRecenses, setNonRecenses] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!loading) {
      setVisualisationLoading(false);
    }
  }, [loading]);

  const handleVisualisation = React.useCallback(() => {
    setVisualisationLoading(true);
    onEdition({ recenses, nonRecenses });
  }, [nonRecenses, onEdition, recenses]);

  const content = React.useMemo(
    () => (
      <>
        <h3 style={{ marginBottom: 5 }}>Édition des listes de recensement</h3>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <Form.Checkbox
                data-testid="gestion-trimestre-modal-checkbox-liste-recenses"
                label="Liste des recensés"
                checked={recenses}
                onChange={(
                  _e: React.FormEvent<HTMLInputElement>,
                  data: CheckboxProps,
                ) => setRecenses(data.checked || false)}
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <Checkbox
                data-testid="gestion-trimestre-modal-checkbox-liste-non-recenses"
                label="Liste des non recensés"
                checked={nonRecenses}
                onChange={(
                  _e: React.FormEvent<HTMLInputElement>,
                  data: CheckboxProps,
                ) => setNonRecenses(data.checked || false)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingTop: 5 }}>
            <Grid.Column width={16}>
              {edition ? (
                <p>
                  <i>
                    Dernière édition des listes de recensement effectuée le
                    {` ${edition.toLocaleDateString()}`}
                  </i>
                </p>
              ) : (
                <p>
                  <i>Édition des listes de recensement non effectuée</i>
                </p>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    ),
    [edition, nonRecenses, recenses],
  );

  const actions = React.useMemo(
    () => (
      <Button
        data-testid="modal-gestion-trimestre-bouton-visualisation-listes"
        content="Visualiser"
        color="green"
        onClick={handleVisualisation}
        loading={visualisationLoading}
        style={{ width: 130 }}
        disabled={_.isNil(generation) || loading || isClotured}
      />
    ),
    [
      loading,
      generation,
      visualisationLoading,
      handleVisualisation,
      isClotured,
    ],
  );

  return (
    <ModalGestionTrimestreRow
      icon={iconEdition}
      content={content}
      actions={actions}
    />
  );
};

export default ModalGestionTrimestreRowEdition;
